import type { Stats as StatsT } from "../api";

function fmtRevenue(b: number): string {
  if (b >= 1000) return `$${(b / 1000).toFixed(2)}T`;
  return `$${b.toFixed(0)}B`;
}

function fmtDate(iso: string | null): string {
  if (!iso) return "n/a";
  return iso.slice(0, 10);
}

function relativeDays(iso: string | null): string | undefined {
  if (!iso) return undefined;
  const then = new Date(iso).getTime();
  const now = Date.now();
  const days = Math.floor((now - then) / (1000 * 60 * 60 * 24));
  if (days < 1) return "today";
  if (days === 1) return "1 day ago";
  if (days < 30) return `${days} days ago`;
  if (days < 365) return `${Math.floor(days / 30)} months ago`;
  return `${Math.floor(days / 365)} years ago`;
}

export default function StatsStrip(props: { stats: StatsT }) {
  const s = props.stats;
  return (
    <section class="stat-strip">
      <div class="stat">
        <div class="k">Firms logged</div>
        <div class="v">{s.total}</div>
        <div class="sub">of 500 target</div>
      </div>
      <div class="stat">
        <div class="k">Combined FY revenue</div>
        <div class="v accent">{fmtRevenue(s.combined_revenue_b_usd)}</div>
        <div class="sub">across {s.firms_with_financials} firms</div>
      </div>
      <div class="stat">
        <div class="k">Sectors covered</div>
        <div class="v">{s.sectors}</div>
        <div class="sub">distinct</div>
      </div>
      <div class="stat">
        <div class="k">Last refresh</div>
        <div class="v signal">{fmtDate(s.latest_pulled_at)}</div>
        <div class="sub">{relativeDays(s.latest_pulled_at) ?? "no data"}</div>
      </div>
    </section>
  );
}
